export enum RestrictionType {
    NO_CLOSER_THAN_BIT = 0x01,
    NO_FARTHER_THAN_BIT = 0x02,
    NO_HIGHER_THAN_BIT = 0x03,
    NO_LOWER_THAN_BIT = 0x04,

    AVOID_AREA_BIT = 0x05,
    LIMIT_TO_AREA_BIT = 0x06,

    LIMIT_TO_TIME_BIT = 0x07,
    AVOID_TIME_BIT = 0x08,
    ON_DATE_PERIOD_BIT = 0x09,
    ON_HOUR_PERIOD_BIT = 0x0a,
    ON_WEEKDAY_PERIOD_BIT = 0x0b,

    ON_OPERATION_CATEGORY_BIT = 0x0c,
    MUST_OBSERVER_BIT = 0x0d,

    VOLUME_AS_CIRCLE_BIT = 0x0e,
    VOLUME_AS_RECTANGLE_BIT = 0x0f,
    VOLUME_AS_REGION_BIT = 0x10,
    VOLUME_AS_TRACK_BIT = 0x11,
    VOLUME_AS_REGION_SET_BIT = 0x12,
    VOLUME_AS_TRACK_SET_BIT = 0x13,
    USER_RESERVED_1_BIT = 0x14,
    USER_RESERVED_2_BIT = 0x15,

    VOLUME_AS_COORDINATION_BIT = 0x16,
    VOLUME_AS_RESPONSIBILITY_BIT = 0x17,

    INFO_MESSAGE_BIT = 0x18,
    REQ_MESSAGE_BIT = 0x19,
    SUBMISSION_PERIOD_BIT = 0x1a,
    MUST_COMPLY_WITH_VOLUME_BIT = 0x1b,
    MUST_ATTACH_DOCUMENT_BIT = 0x1c,
    MUST_ALLOW_TRACKING_BIT = 0x1d,

    RESERVED_3_BIT = 0x1e,
    RESERVED_4_BIT = 0x1f,
}